export default "__VITE_ASSET__Vp8uHC9o__"